import { put, call, fork, takeLatest, all } from "redux-saga/effects";
import { CLEAR_API_CALL_MESSAGE, GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION, GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_FAILURE, GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_SUCCESS } from "../Action/actionTypes";
import * as salesRepAPI from '../../services/salesRepClassificationAPI';
import { apiCallFailure, apiCallRequest } from "../Action/Action";

function* getAISummaryForCloseNegotiation(action: any): Generator {
    try {
        yield put(apiCallRequest());
        const payload = action.payload;
        const response: any = yield call(salesRepAPI.getApiForSalesRepAIData, payload)
        if (response.status === 200) {
            yield put({ type: GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_SUCCESS, payload: response.data.result });
            yield put({ type: CLEAR_API_CALL_MESSAGE })
        } else {
            yield put(apiCallFailure("Failed to fetch AI summary.Please try again."));
            yield put({ type: GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_FAILURE });
        }
    } catch (error) {
        yield put(apiCallFailure("Failed to fetch AI summary.Please try again."));
        yield put({ type: GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_FAILURE });
    }
}

function* watchGetAISummaryForCloseNegotiation(): Generator {
    yield takeLatest(GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION, getAISummaryForCloseNegotiation)
}


export function* CloseNegotiationSaga(): Generator {
    yield all(
        [
            fork(watchGetAISummaryForCloseNegotiation)
        ]
    )
}